import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, of, switchMap } from "rxjs";
import { downloadFile } from "src/app/core/helpers";
import { admissionActions, appEventActions } from "src/app/shared/store";
import { AdminAdmissionService } from "../services";
import { adminAdmissionActions } from "./admin-admission.action";

@Injectable({
    providedIn: "root",
})
export class AdminAdmissionEffects {
    constructor(
        private actions$: Actions,
        private adminAdmissionService: AdminAdmissionService,
    ) {}

    scheduleInterview$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.scheduleInterview),
            switchMap((data) =>
                this.adminAdmissionService.scheduleInterview(data.data).pipe(
                    switchMap(() => {
                        data.onClose(true);
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Interview Scheduled Sucessfully",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );

    scheduleBulkInterview$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.scheduleBulkInterviews),
            switchMap((data) =>
                this.adminAdmissionService.scheduleBulkInterview(data.data).pipe(
                    switchMap(() => {
                        data.onClose(true);
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Interviews Scheduled Sucessfully",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );

    changeAdmissionStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.changeAdmissionStatus),
            switchMap((data) =>
                this.adminAdmissionService.changeAdmissionStatus(data.data).pipe(
                    switchMap(() => {
                        data.onClose(true);
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Admission Status Changed Sucessfully",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );

    receiveSepratePayment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.receiveSepratePayment),
            switchMap((data) =>
                this.adminAdmissionService.receiveSepratePayment(data.data).pipe(
                    switchMap((resp) => {
                        console.log("data", data);
                        data.onClose(true);
                        console.log("resp", resp);
                        return of(
                            admissionActions.getAdmissionFeesData({
                                data: {
                                    admissionId: resp.admission,
                                },
                            }),
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Payment Received Sucessfully",
                            }),
                        );
                    }),
                    catchError((err) => {
                        console.log("err", err);
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );

    update$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(adminAdmissionActions.updateEnquiry),
            switchMap((data) =>
                this.adminAdmissionService.updateEnquiry(data.data, data.id).pipe(
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                    switchMap(() => {
                        data.onClose(true);
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Enquiry updated successfully.",
                            }),
                        );
                    }),
                ),
            ),
        );
    });

    sendAdmissionMail$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(adminAdmissionActions.sendAdmissionMail),
            switchMap((data) =>
                this.adminAdmissionService.sendAdmissionMail(data.id, data.email).pipe(
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                    switchMap(() => {
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Admission mail sent successfully.",
                            }),
                        );
                    }),
                ),
            ),
        );
    });

    exportAdmissionExcel$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.exportAdmissionExcel),
            switchMap((data) =>
                this.adminAdmissionService.exportAdmissionsExcel(data?.status).pipe(
                    switchMap((response) => {
                        downloadFile(response.file);
                        return of(
                            appEventActions.addToast({
                                detail: "Excel downloaded successfully.",
                                severity: "success",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );

    exportEnquiriesExcel$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.exportEnquiriesExcel),
            switchMap((data) =>
                this.adminAdmissionService.exportEnquiriesExcel().pipe(
                    switchMap((response) => {
                        downloadFile(response.file);
                        return of(
                            appEventActions.addToast({
                                detail: "Excel downloaded successfully.",
                                severity: "success",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );

    exportIdCardExcel$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.exportIdcardExcel),
            switchMap((data) =>
                this.adminAdmissionService.exportIdCardExcel().pipe(
                    switchMap((response) => {
                        console.log("---------", response);
                        downloadFile(response.file);
                        return of(
                            appEventActions.addToast({
                                detail: "Excel downloaded successfully.",
                                severity: "success",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );

    previewMigration$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.previewMigration),
            switchMap((data) => {
                return this.adminAdmissionService.previewMigration(data.data).pipe(
                    switchMap((response: any) => {
                        if(response.blocking_errors.length > 0){
                            return of(appEventActions.addToast({
                                severity: "error",
                                detail: response.blocking_errors.join(", "),
                            }));
                        }
                        data.onSuccess(response);
                        return of(appEventActions.emptyAction());
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                )}
            ),
        ),
    );

    executeMigration$ = createEffect(() =>
        this.actions$.pipe(
            ofType(adminAdmissionActions.executeMigration),
            switchMap((data) => {
                return this.adminAdmissionService.executeMigration(data.data).pipe(
                    switchMap((response: any) => {
                        data.onSuccess(response);
                        return of(appEventActions.emptyAction());
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                )}
            ),
        ),
    );
}
